import { ModelError_Response } from '@treadinc/horizon-api-spec';
import { isAxiosError } from 'axios';
import { upperFirst } from 'lodash-es';

// A 422 carries the server's reason, e.g. no jobs match or too many jobs to render.
export function getPdfRenderValidationMessage(error: unknown) {
  const isValidationError =
    isAxiosError<ModelError_Response>(error) && error.response?.status === 422;
  const validationMessage = isValidationError
    ? error.response?.data.error.errors?.[0]?.message
    : undefined;

  return validationMessage ? upperFirst(validationMessage) : undefined;
}
